module.exports = __webpack_public_path__ + "static/media/duck.2c08a155.png";